import axios from "../axios-config";

export const getWorkspaceSummaryApi = async () => {
    const response = await axios.get("/organization/v1/workspace");
    return response?.data?.data || null;
};

export const getWorkspaceArtistsApi = async () => {
    const response = await axios.get("/organization/v1/artists");
    return response?.data?.data || { activeArtistProfileId: null, artists: [] };
};

export const createWorkspaceArtistApi = async (payload) => {
    const response = await axios.post("/organization/v1/artists", payload);
    return response?.data?.data || null;
};

export const switchArtistContextApi = async (artistProfileId) => {
    const response = await axios.patch("/organization/v1/context/artist", { artistProfileId });
    return response?.data?.data || null;
};
